<template>
  <div>
    <div class="buttonDimensions">
      <b-button
        title="Ansi Notes Template"
        @click="getAnsiNotes()"
        class="greenBtn noteIcon"
      >
        <fa :icon="['fas', 'cog']" size="sm"/>
      </b-button>
    </div>
    
    <b-modal
      id="AnsiNotesModal"
      title="ANSI Notes Template"
      title-tag="b"
      size="lg"
      content-class="menu-bg-blue-transparent-modal nt-modal"
      header-close-variant="light"
      hide-footer
    >
      <b-container>
        <b-row class="py-2">
          <b-col class="col-sm-12 px-5">
            <div class="field px-5">
              <label for="Notes">Note *</label>
              <b-form-textarea
                name="note"
                v-model="form.note"
                autocomplete="off"
              />
            </div>
          </b-col>
        </b-row>
        <b-container class="px-5" v-if="formSubmitErrors.length" id="formSubmitErrorsWindow">
          <b-col class="text-center">
            <span>
              <b>Please correct the following error(s):</b>
              <ul class="list-group">
                <div
                  class="alert alert-danger"
                  v-for="error in formSubmitErrors"
                  :key="error"
                >
                  <li class="list-group-item">{{ error }}</li>
                </div>
              </ul>
            </span>
          </b-col>
        </b-container>

        <b-row class="p-2" v-if="submitSuccess" id="formSubmitSuccessWindow">
          <b-col class="text-center">
            <span class="ml-3">
              <b class="alert alert-success">{{ this.submitSuccess }}</b>
              <fa
                :icon="['fas', 'window-close']"
                @click="submitSuccessHide()"
              />
            </span>
          </b-col>
        </b-row>

        <b-row class="p-3">
          <b-col class="text-center">
            <b-button
              variant="primary"
              class="btn-md"
              type="submit"
              @click="checkForm()"
            >
              Submit
            </b-button>
            <b-button
              v-if="this.updateEntryID"
              variant="primary"
              class="btn-md m-3"
              type="submit"
              @click="clearNotes()"
            >
              Clear
            </b-button>
          </b-col>
        </b-row>
      </b-container>
      <b-container>
        <vue-bootstrap4-table
          :rows="notesRows"
          :columns="notesColumns"
          :config="config"
          :classes="classes"
        >
          <template slot="update" slot-scope="props">
            <b-button variant="info" @click="editEntry(props.row)">
              <fa :icon="['fas', 'pencil-alt']" size="lg" />
            </b-button>
          </template>
          <template slot="delete" slot-scope="props">
            <b-button variant="danger" @click="deleteEntry(props.row)">
              <fa :icon="['fas', 'minus']" size="lg" />
            </b-button>
          </template>
        </vue-bootstrap4-table>
      </b-container>
    </b-modal>
  </div>
</template>

<style>
@media (max-width: 470px) {
  .xs-spacing {
    padding-top: 2rem;
  }
}
@media (min-width: 768px) {
  .modal-width {
    width: 65%;
    max-width: 700px;
  }
}
.info-tooltip {
  position: relative;
  display: inline-block;
}
.info-tooltip .info-tooltip-text {
  visibility: hidden;
  width: 100px;
  font-size: 15px;
  top: 18%;
  margin-left: 30px;
  background-color: #212529;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 200000;
}
.info-tooltip:hover .info-tooltip-text {
  visibility: visible;
}
.noteIcon {
  height: 22px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px;
}
.buttonDimensions {
  display: flex;
  justify-content: center;
  align-items: center;
}
.nt-modal .menu-bg-blue-transparent,
.nt-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.nt-modal label { color: rgba(6, 60, 109, 0.7); }
.nt-modal .form-control {
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  color: #063c6d !important;
}
.nt-modal .form-control::placeholder { color: rgba(6, 60, 109, 0.35); }
.nt-modal .form-control:focus {
  background: #fff !important;
  border-color: #063c6d !important;
  box-shadow: 0 0 0 2px rgba(6, 60, 109, 0.12) !important;
}
.nt-modal table { color: #063c6d !important; text-shadow: none !important; }
.nt-modal thead th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-shadow: none !important;
}
.nt-modal thead th a,
.nt-modal thead th svg { color: rgba(6, 60, 109, 0.5) !important; }
.nt-modal thead th input {
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  color: #063c6d !important;
  font-size: 0.85rem;
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
}
.nt-modal tbody tr { color: #063c6d !important; text-shadow: none !important; }
.nt-modal tbody tr:hover { background: rgba(6, 60, 109, 0.04) !important; }
.nt-modal tbody td {
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.08) !important;
  text-shadow: none !important;
}
.nt-modal .footer-pagination-row td,
.nt-modal .footer-pagination-row th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  text-shadow: none !important;
}
</style>

<script>
import VueBootstrap4Table from 'vue-bootstrap4-table'
import axios from 'axios'
export default {
  name: 'MMP_NotesTemplate',
  components: {
    VueBootstrap4Table
  },
  data() {
    return {
      submitSuccess: '',
      formSubmitErrors: [],
      form: {
        note: null
      },
      notesRows: [],
      classes: {
        table: {
          'menu-bg-blue-transparent': true
        }
      },
      notesColumns: [
        {
          label: 'Notes',
          name: 'note',
          sort: true
        },
        {
          label: 'Update',
          name: 'update',
          sort: false
        },
        {
          label: 'Delete',
          name: 'delete',
          sort: false
        }
      ],
      config: {
        checkbox_rows: false,
        rows_selectable: true,
        card_mode: false,
        global_search: {
          placeholder: 'Search...',
          visibility: true,
          showClearButton: true,
          searchOnPressEnter: true
        },
        highlight_row_hover_color: 'rgba(6,60,109,0.04)',
        show_refresh_button: false,
        show_reset_button: false
      },
      updateEntryID: null
    }
  },
  methods: {
    submitSuccessHide() {
      this.submitSuccess = ''
    },
    clear() {
      this.form.note = null
      this.formSubmitErrors = []
    },
    submit() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/ansi_notes/addAnsiNotes', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              note: this.form.note
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('addAnsiNotes API Call Error: ' + content.errors)
            } else {
              this.$bvToast.toast('Note added successfully.', {
                title: 'Status',
                toaster: 'b-toaster-top-center'
              })
            }
            this.getAnsiNotes()
            this.clear()
            this.$emit('updateNotes')
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    checkForm: function () {
      this.formSubmitErrors = []
      if (!this.form.note) {
        this.$bvToast.toast('Please enter note.', {
          title: 'Error',
          toaster: 'b-toaster-top-center'
        })
      } else {
        if (!this.updateEntryID) {
          this.submit()
        } else {
          this.updateEntry()
        }
      }
    },
    getAnsiNotes() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/ansi_notes/getAnsiNotes', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            this.notesRows = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.$router.push({name: 'Login'})
      }
      this.$bvModal.show('AnsiNotesModal')
    },
    editEntry(row) {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/ansi_notes/getNotes', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              id: row.id
            }
          })
          .then(response => {
            const content = response.data[0]
            if (content.errors) {
              console.log('Update Entry API Call Error: ' + content.errors)
              // Else no errors and we can load returned entry into form
            } else {
              this.form = {
                note: content.note
              }
              this.updateEntryID = content.id
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    deleteEntry(row) {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/ansi_notes/deleteNotes', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              id: row.id
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('Delete Entry API Call Error: ' + content.errors)
              // Else no errors and we can load returned entry into form
            } else {
              for (let i = this.notesRows.length - 1; i >= 0; i--) {
                if (this.notesRows[i].id === row.id) {
                  this.notesRows.splice(i, 1)
                }
              }
              this.$bvToast.toast('Note deleted.', {
                title: 'Status',
                toaster: 'b-toaster-top-center'
              })
              this.$emit('updateNotes')
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    updateEntry() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/ansi_notes/updateNotes', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-auth-token': sessionStorage.token
            },
            params: {
              notes: this.form.note,
              id: this.updateEntryID
            }
          })
          .then(response => {
            const content = response.data
            if (!content.errors) {
              this.$bvToast.toast('Note updated.', {
                title: 'Status',
                toaster: 'b-toaster-top-center'
              })
              this.clearNotes()
              this.getAnsiNotes()
              this.$emit('updateNotes')
            } else {
              console.log('Update Notes API Call Error: ' + content.errors)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
      // this.clearForm() - REFACTORED -- WEBGIS-2610 -- clearForm() is not a function
    },
    clearNotes() {
      this.form.note = null
      this.updateEntryID = null
    }
  }
}
</script>
